import { BorderColor, TagColor } from '../interface/common';

export enum ConflictSections {
  general = 'general',
  matters = 'matters',
  matterRequests = 'matterRequests',
  conflictChecks = 'conflictChecks',
  notes = 'notes',
}
export const PAYER_ROLE_ID = '63307673-31CB-4BED-9A81-793A05DB022A';
export const DEFAULT_CLIENT_ROLE_IDENTIFIER = '05394BA7-3201-4D8F-8520-E8FC7CB66681';
export const OPPONENT_ROLE_ID = '682F0EDA-AC14-43AD-A772-E4C3BB77122F';
export enum MatterPartyRoleType {
  COPARTY = 'co-party',
  PRINCIPAL = 'principal',
  OPPOSITION = 'opposition',
  OTHER = 'other',
}
export const matterPartyRoleTranslationMapping = {
  [MatterPartyRoleType.COPARTY]: 'matter:matterPartyRole.coparty',
  [MatterPartyRoleType.OPPOSITION]: 'matter:matterPartyRole.opposition',
  [MatterPartyRoleType.OTHER]: 'matter:matterPartyRole.other',
  [MatterPartyRoleType.PRINCIPAL]: 'matter:matterPartyRole.principal',
};
export enum ConflictCheckFilterType {
  ACCEPTED = 'accepted',
  IN_PROGRESS = 'inprogress',
  REJECTED = 'rejected',
}
export const conflictCheckTagColorMapping: {
  [key in ConflictCheckFilterType]: TagColor;
} = {
  [ConflictCheckFilterType.ACCEPTED]: TagColor.GREEN,
  [ConflictCheckFilterType.IN_PROGRESS]: TagColor.YELLOW,
  [ConflictCheckFilterType.REJECTED]: TagColor.RED,
};

export const conflictCheckCardBorderColorMapping: {
  [key in ConflictCheckFilterType]: string;
} = {
  [ConflictCheckFilterType.ACCEPTED]: BorderColor.GREEN,
  [ConflictCheckFilterType.IN_PROGRESS]: BorderColor.YELLOW,
  [ConflictCheckFilterType.REJECTED]: BorderColor.RED,
};
